import { observable } from "mobx";
import { copy } from "../utils/data";

export class Category {
  @observable idHash: string;
  @observable color: string;
  @observable description: string;
  @observable imageId: string;
  @observable name: string;
  @observable textColor: string;
  @observable opportunityCt: number;
  @observable iconId: string;

  constructor(cat?: Category) {
    this.idHash = this.color = this.description = this.imageId = this.name = this.textColor = "";
    this.opportunityCt = 0;
    if (cat) {
      copy(cat, this);
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/category.ts